/** @jsx jsx */
import React from 'react';
import type { BoxProps } from '@balance-web/box';
import { Box } from '@balance-web/box';
import { jsx } from '@balance-web/core';
import { useTheme } from '@balance-web/theme';

export const CodeBlock = ({ code, ...props }: BoxProps & { code: string }) => {
  const theme = useTheme();

  return (
    <Box
      as="pre"
      css={{
        background: theme.semantic.colour.surface.neutral.background1,
        borderRadius: theme.radii.xsmall,
        boxShadow: `0 0 0 1px ${theme.semantic.colour.surface.neutral.border}`,
        fontFamily: theme.typography.fontFamily.monospace,
        fontSize: theme.typography.fontSize.small,
        color: theme.semantic.colour.text.textPrimary,
        lineHeight: 1.4,
        overflow: 'auto',
        padding: 10,

        code: {
          fontFamily: 'inherit',
        },
      }}
      {...props}
    >
      <code>{code}</code>
    </Box>
  );
};
